module.exports = __webpack_public_path__ + "static/media/Vector_3.d36d4264.png";